import { createTheme } from '@material-ui/core/styles'


declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    customColors: {
      main: React.CSSProperties['color'],
      black: React.CSSProperties['color'],
      dark: React.CSSProperties['color'],
      touch: React.CSSProperties['color'],
      inputDisable: React.CSSProperties['color'],
      title: React.CSSProperties['color'],
      dashboardBg: React.CSSProperties['color'],
      menuText: React.CSSProperties['color'],
      cntntCntnr: React.CSSProperties['color'],
      icons: React.CSSProperties['color'],
      disableTitle: React.CSSProperties['color'],
      childBack: React.CSSProperties['color'],
      toolbarIcons: React.CSSProperties['color'],
      customColors: React.CSSProperties['color'],
      mainHover: React.CSSProperties['color'],
      button: React.CSSProperties['color'],
      secondary: React.CSSProperties['color'],
      formBack: React.CSSProperties['color'],
      signBack: React.CSSProperties['color'],
    }
  }
  interface ThemeOptions {
    customColors?: {
      main: string,
      black: string,
      dark: string,
      touch: string,
      inputDisable: string,
      title: string,
      dashboardBg: string,
      menuText: string,
      cntntCntnr: string,
      icons: string,
      disableTitle: string,
      childBack: string,
      toolbarIcons: string,
      mainHover: string,
      button: string,
      secondary: string,
      formBack: string,
      signBack: string,
    },
  }
}
export const lightTheme = createTheme({
  direction: "rtl",

  overrides: {

    MuiOutlinedInput: {
      root: {
        borderRadius: 15,
      },
    },
    MuiFormLabel: {
      root: {
        color: "#BABABA",
        "&.Mui-focused": {
          color: "#BABABA",
        },
      },
    },
    MuiTextField: {
      root: {
        minHeight: 50,
        borderRadius: 15,
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "#000312",
        disabled: {
          backgroundColor: "#282C37",
          border: "none",
        },

      },
      underline: {
        "&:before": {
          display: "none",
        },
      },
    },
    MuiSelect: {
      root: {
        filled: {
          background: "#000312",
          "& .MuiFormLabel-root.Mui-focused": {
            color: "#BABABA",
          },
          "& .MuiFilledInput-underline:before": {
            display: "none",
          },
        },
        disabled: {
          backgroundColor: "#282C37",
          border: "none",
        },
      }
    },
    MuiTable: {
      root: {
        "& .MuiTableCell-sizeSmall": {
          border: "1px solid #4A4C59",
        },
      },
    },
    MuiInputBase: {
      root: {
        minHeight: 50,
      },
    },
    MuiButton: {
      contained: {
        height: 50,
        borderRadius: 15,
        background: "linear-gradient(#250858 ,#250858)",
        color: "white"
      },
      label: {
        color: "white",
      },
      containedSizeSmall: {
        height: 27,
        margin: "5px 0",
        borderRadius: 10,
        background: "linear-gradient(#272934 ,#272934)",
        "& .MuiButton-label": {
          color: "#FCD300",
          fontSize: 10,
        },
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: "#000312",
      },
    },
    MuiTableBody: {
      root: {
        "& tr:nth-child(1n)": {
          backgroundColor: "#5B6382",
        },
        "& tr:nth-child(2n)": {
          backgroundColor: "#43454E",
        },
        "& tr.Mui-selected": {
          backgroundColor: "#907d45",
        },
      },
    },
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "#43454Ecc !important",
        },
      },
    },
    MuiTableCell: {
      head: {
        textAlign: "center",
        color: "#FFD739",
        verticalAlign: "bottom",
      },
      body: {
        color: "#D1D1D1",
        textAlign: "center",
      },
    },
    MuiTypography: {
      root: {
        color: "#ecebec",
      },
    },
    MuiInput: {
      root: {
        backgroundColor: "#000312",
        input: {
          padding: "0 5px",
        },
        "&$disabled": {
          backgroundColor: "#282C37",
          border: "none",
        },

      },
      underline: {
        "&:before, &:after": {
          display: "none",
        },
      },
    },
    MuiMenu: {
      paper: {
        background: "white",
      },
    },
    MuiSnackbar: {
      root: {
        "& .MuiAlert-filledSuccess": {
          color: "#000",
          backgroundColor: "#78DF97",
        },
        "& .MuiAlert-filledInfo": {
          color: "#fff",
          backgroundColor: "#52BAD5",
        },
        "& .MuiAlert-filledWarning": {
          color: "#000",
          backgroundColor: "#FFBE0A",
        },
        "& .MuiAlert-filledError": {
          color: "#fff",
          backgroundColor: "#D14545",
        },
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: 18,
        marginBottom: 16,
      },
    },
  },
  palette: {
    type: "light",
    primary: {
      main: "#000",
    },
    secondary: {
      main: "#FFD739",
    },
    text: {
      primary: "#250858",
      secondary: "#FFD739",
    },
    background: {
      paper: "#282C37",
    },
  },
  customColors: {
    main: "#001E50",
    black: "#000",
    dark: "#2D3CD7",
    inputDisable: "#282C37",
    title: "black",
    dashboardBg: "#3a539b36",
    menuText: "#ecebec",
    cntntCntnr: "rgb(233 241 251)",
    icons: "#374785",
    disableTitle: "#2d2c2c",
    childBack: "#FFFFFF",
    toolbarIcons: "#374785",
    mainHover: "#3a0d89",
    button: "#2D3CD7",
    secondary: "#FF4F01",
    signBack: "#FFFFFF85",
    formBack: "white",
    touch: "#26B7A6",
  },
});
